/* eslint-disable no-undef */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import Imagen from '../../Imagen/Imagen';
import Botonera from '../../Botonera/Botonera';
import usePrecargaImagenes from '../../../hooks/usePrecargaImagenes';
import useListadoImagenes from '../../../hooks/useListadoImagenes';

import moment from 'moment';

import { Box, Container } from '@mui/material';

import CircularProgress from '@mui/material/CircularProgress';
import CustomSlider from '../../CustomSlider/CustomSlider';
import { imagenAnerior, imagenSiguiente, pause, reproducir, stop } from '../controls';
import Referencias from './Referencias/Referencias';
import { Modal } from 'materialize-css';
import { ModalReferencia } from './Referencias/ModalReferencia';





//  "homepage": "https://www.inumet.gub.uy/reportes/pages/visualizador_indice_uv/",
const TITLE = "Visualizador Índice UV - INUMET";
const DATE_FORMAT_TO_DISPLAY = "DD/MM/YYYY HH:mm";
const IMAGE_BASE_NAME_FORMAT = "YYYYDDDD_HHmm";
// const IMAGE_BASE_PATH = "https://www.inumet.gub.uy/reportes/indice_uv/";
const IMAGE_BASE_PATH = "https://www.inumet.gub.uy/reportes/geonetcast/LES-inidice_uv/";
// El servidor publica en este JSON las rutas de las imágenes disponibles y lo actualiza solo.
const LISTADO_URL = "https://www.inumet.gub.uy/reportes/geonetcast/uv.json";
const CLAVE_LISTADO = "LES-inidice_uv";
const PREFIJO_UV = "iuv_";
const PREFIJO_UVCSK = "iuvcsk_";
const EXTENCION = "webp";
const MAX_DATE_INTERVAL = [12, 'hours'];
// Cuántas imágenes precargar a cada lado de la posición actual. Subirlo da más colchón
// contra la latencia durante la reproducción, a costa de más pedidos al abrir el sitio.
const VENTANA_PRECARGA = 2;
//const DESCRIPTION = "<p>El Índice Ultravioleta (Índice UV) es un estandar internacional para indicar el riesgo de exposición a la radiación ultravioleta incidente en la superficie terrestre.</p> <p>En este visualizador se presentan dos paneles con estimaciones del Índice UV a través de imagenes satelitales.</p><p> El panel izquierdo presenta el Índice UV estimado, mientras que el panel derecho presenta el Índice UV estimado en condiciones de cielo despejado, es decir sin tener en cuenta la nubosidad presente.</p> <p> De esta forma el Índice UV (Con cielo despejado) muestra el peor escenario posible de exposición a la radiación ultravioleta de origen solar.</p>";
const DESCRIPTIONUV = '<h2>ÍNDICE ULTRAVIOLETA (IUV)</h2> \
<p>Es un estándar internacional para indicar el riesgo de exposición a la radiación ultravioleta incidente en la superficie terrestre en un determinado momento y lugar.</p><p> El Instituto Uruguayo de Meteorología (INUMET) y el Laboratorio de Energía Solar (LES) - Facultad de Ingeniería y CENUR Litoral Norte (Udelar), construyó y aplicó un modelo satelital para la estimación de Índice Ultravioleta (IUV) a través de la UV-E (Ultravioleta-Eritérmica), la cual está relacionada directamente con el efecto de esta radiación sobre la piel humana. \
</p>';

const DESCRIPTIONINTERPRETAR = '<h2>¿Cómo interpretar las imágenes?</h2>\
<p>En este visualizador se presentan dos paneles con estimaciones del IUV a través de imágenes satelitales, con valores que incrementan de acuerdo a la peligrosidad de la exposición a esta radiación.</p> \
<p>El panel izquierdo presenta el IUV estimado.</p> \
<p> El panel derecho presenta el IUV estimado en condiciones de cielo despejado, es decir sin tener en cuenta la nubosidad presente; de esta forma muestra el peor escenario posible de exposición a la radiación ultravioleta de origen solar. </p> \
<p>Las imágenes son actualizadas cada 10 minutos.</p>';

export const PlayerUv = () => {
    // La línea de tiempo es el índice del servidor; las imágenes son una caché que se
    // llena por demanda, así que no se deriva de lo que ya está descargado.
    const { listado: listadoImagenes, error: errorListado, isLoading: isLoadingListado } = useListadoImagenes({
        LISTADO_URL,
        CLAVE_LISTADO,
        prefijos: [PREFIJO_UV, PREFIJO_UVCSK],
        extencion: EXTENCION,
        IMAGE_BASE_NAME_FORMAT,
        MAX_DATE_INTERVAL
    })
    const [fechaMuestra, setFechaMuestra] = useState('')
    const [velocidad, setVelocidad] = useState(800)
    const [idReproduccion, setIdReproduccion] = useState(0)
    const [posicion, setPosicion] = useState(0);
    const [reproduciendo, setReproduciendo] = useState(0)


    const handleMouseMove = (e) => {
        const image = imageRef.current;
        const rect = image.getBoundingClientRect();

        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;

        const canvas = document.createElement('canvas');
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, image.width, image.height);

        const pixel = ctx.getImageData(x, y, 1, 1).data;
        const color = `rgb(${pixel[0]}, ${pixel[1]}, ${pixel[2]})`;

        console.log('Color:', color);
    };


    const { images: imagenes_uv, error: error_uv } = usePrecargaImagenes(
        {
            prefijo: PREFIJO_UV,
            sufijo: '',
            fechas: listadoImagenes,
            posicion,
            ventanaPrecarga: VENTANA_PRECARGA,
            extencion: EXTENCION,
            IMAGE_BASE_PATH
        })
    const { images: imagenes_uvcsk, error: error_uvcsk } = usePrecargaImagenes(
        {
            prefijo: PREFIJO_UVCSK,
            sufijo: '',
            fechas: listadoImagenes,
            posicion,
            ventanaPrecarga: VENTANA_PRECARGA,
            extencion: EXTENCION,
            IMAGE_BASE_PATH
        })

    // Mientras la imagen de la posición actual no esté en caché se mantiene la última
    // mostrada, para que el bucle no parpadee si la red se atrasa.
    const fechaActual = listadoImagenes[posicion]
    const ultimaUv = useRef(null)
    const ultimaUvcsk = useRef(null)
    if (imagenes_uv[fechaActual]) ultimaUv.current = imagenes_uv[fechaActual]
    if (imagenes_uvcsk[fechaActual]) ultimaUvcsk.current = imagenes_uvcsk[fechaActual]




    const formatearFechaMuestra = useCallback(() => {
        if (listadoImagenes.length === 0) return
        const date = moment.utc(listadoImagenes[posicion], IMAGE_BASE_NAME_FORMAT)
        setFechaMuestra(date.local().format(DATE_FORMAT_TO_DISPLAY))
    }, [posicion, listadoImagenes])





    useEffect(() => {
        if (reproduciendo === 1) {
            setTimeout(() => {
                imagenSiguiente({ reproduciendo, listadoImagenes, posicion, setPosicion })
            }, velocidad)
        }
        formatearFechaMuestra()
    }, [reproduciendo, posicion, idReproduccion, velocidad, formatearFechaMuestra, listadoImagenes])

    useEffect(() => {
        document.title = TITLE
    }, [])


    // Sin listado, o sin haber podido mostrar una sola imagen, no hay nada que reproducir:
    // sin este corte el spinner giraría indefinidamente.
    const sinImagenes = !ultimaUv.current || !ultimaUvcsk.current
    if (errorListado
        || (!isLoadingListado && listadoImagenes.length === 0)
        || ((error_uv || error_uvcsk) && sinImagenes)) return <Box
        sx={{
            display: "flex",
            width: "100vw",
            justifyContent: "center",
            textAlign: "center",
            fontFamily: "Roboto",
            fontSize: "1rem",
            color: 'primary.dark',
            pt: { xs: 10, sm: 30 },
        }}
    >
        <p>Por el momento no hay imágenes disponibles. Volvé a intentar en unos minutos.</p>

    </Box>

    // El spinner es solo para el arranque: una vez que se mostró el primer par de
    // imágenes, las que falten se cubren con la última mostrada.
    if (sinImagenes) return <Box
        sx={{
            display: "flex",
            width: "100vw",
            height: "100vh",
            justifyContent: "center",
            alignItems: "flex-start",
            justifyItems: "center",
            pt: { xs: 10, sm: 30 },
        }}
    >
        <CircularProgress color="primary" />

    </Box>

    return (
        <Container maxWidth="false"


            sx={{

                display: "flex",
                flexDirection: "column",
                margin: 0,
                padding: 0,
            }}
        >
            <Botonera
                stop={() => stop({ idReproduccion, setReproduciendo, setPosicion, setIdReproduccion })}
                pause={() => pause({ idReproduccion, setReproduciendo })}
                aumentarVelocidad={() => setVelocidad(velocidad - 100)}
                disminuirVelocidad={() => setVelocidad(velocidad + 100)}
                reproducir={() => reproducir({ reproduciendo, setReproduciendo })}
                imagenSiguiente={() => imagenSiguiente({ reproduciendo, listadoImagenes, posicion, setPosicion })}
                imagenAnerior={() => imagenAnerior({ listadoImagenes, posicion, setPosicion })}
                reproduciendo={reproduciendo}
            />


            <CustomSlider reproduciendo={reproduciendo} listadoImagenes={listadoImagenes} posicion={posicion} setPosicion={setPosicion} fechaMuestra={fechaMuestra} />

            <Box
                sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    maxWidth: "100vw",
                    maxHeight: "100vh",
                    justifyContent: "center",
                }}
            >
                <Box
                    sx={{
                        display: "grid",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100vw",
                        gridTemplateColumns: { xs: "100vw", sm: "40vw 40vw" },

                    }}
                >

                    <Imagen src={imagenes_uv[fechaActual] ?? ultimaUv.current} error={error_uv} />
                    <Imagen src={imagenes_uvcsk[fechaActual] ?? ultimaUvcsk.current} error={error_uvcsk} />

                    <Box></Box>
                    <Box
                        sx={{

                            textAlign: "right",
                            flexGrow: 1,
                            p: { xs: 0, sm: 3 },

                        }}
                    >
                        <ModalReferencia description={DESCRIPTIONUV} buttonText="¿Qué es el Índice UV?" />
                        <ModalReferencia description={DESCRIPTIONINTERPRETAR} buttonText="Sobre el producto" />
                    </Box>
                </Box>

                <Referencias />





                <Box
                    sx={{
                        fontSize: "1rem",
                        fontFamily: "Roboto",
                        textAlign: "left",
                        color: 'primary.contrastText',
                        backgroundColor: 'primary.main',
                        p: 0,
                        m: 0,
                        maxWidth: { xs: "100vw", sm: "calc(14rem * 5)" },
                        '& > div': {
                            p: '1em',
                        }


                    }}
                >
                    {/* <div dangerouslySetInnerHTML={{ __html: DESCRIPTIONUV }} /> */}
                </Box>

                <Box
                    sx={{
                        backgroundColor: 'primary.main',
                        display: { xs: 'flex', lg: 'none' },
                        width: "100%",
                        maxWidth: 'calc(14rem * 5)',
                        justifyContent: "center",
                        pb: 2,
                        img: {
                            maxWidth: '15em',
                            height: 'auto',
                        }

                    }}
                >
                    <img
                        width={'100%'}
                        height={'auto'}
                        src={`${process.env.PUBLIC_URL}/assets/logo_inumet.svg`} alt="Logo INUMET" />
                </Box>
            </Box>
        </Container >
    );
}


